import axios from 'axios';

// endpoints
// /login
// /register

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://api.exacter.online/api",
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    "Accept": "application/json",
  },
});


export default api;